import React from "react";

const NextStepArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M11.0139 21.9548L21.0767 11.8921L11.0139 1.82942"
      stroke="white"
      strokeWidth="2.5"
    />
    <path d="M0.95166 11.8921H20.6196" stroke="white" strokeWidth="2.5" />
  </svg>
);

export default NextStepArrow;
